import { render } from "./DDoctors.vue?vue&type=template&id=565ee614&scoped=true"
import script from "./DDoctors.vue?vue&type=script&lang=js"
export * from "./DDoctors.vue?vue&type=script&lang=js"

import "./DDoctors.vue?vue&type=style&index=0&id=565ee614&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-565ee614"]])

export default __exports__